import type {MouseEventHandler} from 'react';
import { useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './font-delete-button.module.scss';

interface FontDeleteButtonProps {
  id?: string;
  className?: string;

  onDeleteConfirm: MouseEventHandler;
}

export function FontDeleteButton({...props}: FontDeleteButtonProps) {
  const [showConfirmationIcons, setShowConfirmationIcons] = useState<boolean>(false);

  const getCommonIconContainerStyles = () => {
    return ['spacing-p-3', 'hover-transition-all', 'radius-2', 'spacing-m-l-1'].join(' ');
  };

  const getDeleteIconContainer = () => {
    return (
      <Icon
        icon="icon-delete"
        onClick={() => {
          return setShowConfirmationIcons(true);
        }}
        className={`color-danger-100 ${styles.deleteIcon} ${getCommonIconContainerStyles()}`}
        size={IconSize.SIZE_ICON_24}
      />
    );
  };

  const getConfirmationIconsContainer = () => {
    return (
      <div className="flexbox">
        <Icon
          icon="icon-check"
          size={IconSize.SIZE_ICON_24}
          onClick={props.onDeleteConfirm}
          className={`color-danger-100 ${styles.deleteConfirmIcon} ${getCommonIconContainerStyles()}`}
        />
        <Icon
          icon="icon-close"
          size={IconSize.SIZE_ICON_24}
          onClick={() => {
            return setShowConfirmationIcons(false);
          }}
          className={`${styles.cancelIcon} ${getCommonIconContainerStyles()}`}
        />
      </div>
    );
  };

  return <div>{showConfirmationIcons ? getConfirmationIconsContainer() : getDeleteIconContainer()}</div>;
}
